// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a4c7635c","455":"1777aeb2"}[chunkId] + ".chunk.js";
};